import { render } from "./GeolocationButton.vue?vue&type=template&id=1c707350&scoped=true"
import script from "./GeolocationButton.vue?vue&type=script&lang=js"
export * from "./GeolocationButton.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1c707350"

export default script